import React from "react";
import { Todo } from "../DTOs/TodoObject";
import { useLocalStorage } from "./UseLocalStorage";

class componentContext {
  public provider: any;
  public consumer: any;

  constructor(data: componentContext) {
    this.provider = data.provider;
    this.consumer = data.consumer;
  }
}

const TodoContext = React.createContext({});

function TodoProvider(props: any) {
  /*{
  // aqui estamos creando los estados, y tambien sus funciones para modificarlos
  // el primero es el valor, el segundo es la funcion que lo hace
  // el useState es un hook, que es una funcion que nos permite usar estados en un componente funcional
  }*/
  // hook customizado utilizado
  const {todos, saveTodos, loading, error} = useLocalStorage('TODOS_V1', []);
  // hook propio de react
  const [searchValue, setSearchValue] = React.useState('');
  const [openModal, setOpenModal] = React.useState(false);
  
  // const [todos, setTodos] = React.useState(parsedItem);

  const completedTodos = (todos as Todo[]).filter(todo => !!todo.completed).length;
  const totalTodos = todos.length;

  let searchedTodos: Todo[] = [];

  if (searchValue.length < 1) {
    searchedTodos = todos;
  } else {
    searchedTodos = (todos as Todo[]).filter(todo => {
      const todoText = todo.text.toLowerCase();
      const searchText = searchValue.toLowerCase();
      return todoText.includes(searchText);
    });
  }

  const addTodo = (text: string) => {
    const newTodos: Todo[] = [...todos];
    newTodos.push({
      completed: false,
      text
    } as Todo);
    saveTodos(newTodos);
  };

  const completeTodo = (text: string) => {
    const todoIndex = (todos as Todo[]).findIndex(todo => todo.text === text);
    const newTodos: Todo[] = [...todos];
    newTodos[todoIndex].completed = newTodos[todoIndex].completed ? false : true;
    saveTodos(newTodos);
  };

  const deleteTodo = (text: string) => {
    const todoIndex = (todos as Todo[]).findIndex(todo => todo.text === text);
    const newTodos: Todo[] = [...todos];
    newTodos.splice(todoIndex, 1);
    saveTodos(newTodos);
  };


  return (
    // el provider es el que va a proveer los datos a los componentes hijos
    // value son los estados que se van a compartir, se comparten las props
    <TodoContext.Provider value={{
      loading,
      error,
      totalTodos,
      completedTodos,
      searchValue,
      setSearchValue,
      searchedTodos,
      completeTodo,
      deleteTodo,
      openModal,
      setOpenModal,
      addTodo
    }}>
      {props.children}
    </TodoContext.Provider>
  );
}

export { TodoContext, TodoProvider };
